class ConfiguratorManualFeModalEditProductProjectFile {
    constructor($http, $window, close, file, product_letter_id, translateService) {
        'ngInject';

        this.$http = $http;
        this.file = file;
        this.productLetterId = product_letter_id;
        this.closeCallback = close;
        this.error = false;
        this.allowedMimeTypes = ['cdr', 'svg', 'pdf', 'dwg', 'dxf', 'eps', 'application/octet-stream', 'text/plain', 'image/svg+xml', 'application/cmx', 'application/x-cmx', 'drawing/cmx', 'image/x-cmx', 'application/cdr', 'application/coreldraw', 'application/x-cdr', 'application/x-coreldraw', 'application/vnd.corel-draw', 'image/cdr', 'image/x-cdr', 'image/x-coreldraw', 'zz-application/zz-winassoc-cdr', 'application/pdf', 'application/x-pdf', 'application/acrobat', 'applications/vnd.pdf', 'text/pdf', 'text/x-pdf', 'application/acad', 'application/x-acad', 'application/autocad_dwg', 'image/x-dwg', 'application/dwg', 'application/x-dwg', 'application/x-autocad', 'image/vnd.dwg', 'drawing/dwg', 'application/dxf', 'application/x-autocad', 'application/x-dxf', 'drawing/x-dxf', 'image/vnd.dxf', 'image/x-autocad', 'image/x-dxf', 'zz-application/zz-winassoc-dxf', 'application/postscript', 'application/eps', 'application/x-eps', 'image/eps', 'image/x-eps'];
        this.allowedExtensions = ['cdr', 'svg', 'pdf', 'dwg', 'dxf', 'eps', 'ai'];
        this.translate = translateService;
    }

    save() {
        if (this.file && this.allowedMimeTypes.indexOf(this.file.fileType) == -1) {
            this.error = this.translate.t('configuratorManual.errors.invalidExtension', {allowedExtensions: 'CDR, SVG, PDF, DWG, DXF, EPS, AI'});
            return;
        }

        if (this.file && this.file.fileSize > 10000240) {
            this.error = this.translate.t('configuratorManual.errors.maximumFileSize', {filesize: '10 MB'});
            return;
        }

        this.closeCallback(this.file, 200);
    }

    close() {
        this.closeCallback(false, 200);
    }
}

export default ConfiguratorManualFeModalEditProductProjectFile;